import * as ENDPOINTS from "routes/ApiEndpoints";
import { AJ_WEB_CONNECTOR } from "Constants";
import FormBuilder from "components/common/services/form/FormBuilder";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import { t, translate } from "components/CentralDataMangement/translation/Translation";
import { useParams } from "react-router-dom";
import { validateRequired } from "components/common/services/ValidationService";

interface FormProps {
    id?: number | string;
}

const LlmProvider: React.FC<FormProps> = ({ id }) => {
    const { id: routeId } = useParams<{ id: string }>();

    const permissionType = id ? "update" : "create";
    const permissionObject: any = {
        permission: "Content creation",
    };
    permissionObject[permissionType] = true;

    const FormValidation = {
        name: [validateRequired],
        slug: [validateRequired],
        description: [validateRequired],
        authType: [validateRequired],
    };

    return (
        <AccessControl
            requiredPermissions={[permissionObject]}
            renderNoAccess={true}
        >
            <FormBuilder
                title={routeId === undefined ? t("Add provider") : t("Edit provider")}
                formName={"LlmProvider"}
                entryId={id || routeId}
                validationRules={FormValidation}
                getDataAPI={`/${ENDPOINTS.GET_LLM_DETAILS}`}
                SaveDataAPI={`/${ENDPOINTS.CREATE_OR_UPDATE_LLM_DETAILS}`}
                microService={AJ_WEB_CONNECTOR}
                backButton={true}
                redirect={-1}
                type="provider"
            />
        </AccessControl>
    );
};

export default translate(LlmProvider);
